
import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

 const FoundEditPopMain = () => {

     var checkname=localStorage.getItem('username')
     let EditData = JSON.parse(localStorage.getItem("EditData"));


     let userName = EditData.map((item) => item.userName);

     let UserName = userName[0]

     let email= EditData.map((item) => item.email);
    

     let Email =email[0]
     let active= EditData.map((item) => item.active);

     let ActiveState = active[0]

     let id= EditData.map((item) => item.id)

     let Id= id[0]

     const token = JSON.parse(localStorage.getItem('usertoken'));


     function GeneratePassword() {

 
        var NewPass =Pass()+ '@123';
     
     
        console.log(NewPass)
        const body ={email: Email, newPassword:NewPass}
     
     
     axios({
          method: "POST",
          url :`${BASE_URL}/Foundation/Generatepassword`,
        //   url:'https://localhost:44312/Api/Foundation/Generatepassword',
           data:body, 
           headers: {
            "Content-Type": "application/json",
           
           }     
           }) 
           .then((response) =>{
             console.log(response.data);
           
           
            if(response.data.status === "Error"){
                
                 toast.error("InCorrect Password")
               }
           
               else if(response.data.status === "Success"){
                 document.getElementById("Gpass").innerHTML=NewPass;
                 alert("Password generated" + " " + "for" + " " + UserName)
                //  toast.success("Password Generated" + " "+ UserName, {
                //    position: "top-center",
                //    autoClose: 3200,
                //    hideProgressBar: false,
                //    closeOnClick: true,
                //    pauseOnHover: true,
                //    draggable: true,
                //    progress: undefined,
                //    className: 'toast-message'
                //    });
                 
                
                
           
               }
             })
             .catch(error => {
               console.log(error);
             //  alert("failed !")
     
             })
             
     
      }
     
      const Allowed = {
         Uppers: "QWERTYUIOPASDFGHJKLZXCVBNM",
         Lowers: "qwertyuiopasdfghjklzxcvbnm",
        //  Numbers: "1234567890",
        //  Symbols: "!@#$%^&*"
     }
     
     const getRandomCharFromString = (str) => str.charAt(Math.floor(Math.random() * str.length))
     
     /**
      * the generated password will be @param length, which default to 8, 
      * and will have at least one upper, one lower, one number and one symbol
      * @param {number} length - password's length
      * @returns a generated password
      */
     const Pass = (length = 6) => {
         let pwd = "";
         pwd += getRandomCharFromString(Allowed.Uppers);  // pwd will have at least one upper
         pwd += getRandomCharFromString(Allowed.Lowers);  // pwd will have at least one lower
        //  pwd += getRandomCharFromString(Allowed.Numbers);  // pwd will have at least one number
        //  pwd += getRandomCharFromString(Allowed.Symbols); // pwd will have at least one symbol
         for (let i = pwd.length; i < length; i++)
             pwd += getRandomCharFromString(Object.values(Allowed).join(''));  // fill the rest of the pwd with random characters
         return pwd
     
        
     
     }


    const [Active, setActive] =useState(" ")
    
   function updateFound(){
    //var Security = document.getElementById("Gpassword").value
    
    
    if(Active===0){
    
      var Action =0
     }
     else if(Active===1){
      var Action= 1
    
     }
    
     else{
        var Action=ActiveState
    
     }
    
    // if(SPassword!=0){
        
    //   var SecurityPass = SPassword
    // }
    // else{
    //   var SecurityPass = Security
    
    // }
      
    // var Gpass = document.getElementById("Gpass").value;
    var EditName = document.getElementById("EditName").value;
    
    
    if(!EditName){
    document.getElementById("ErrA").innerHTML="UserName Required"
    
    }
    else if(EditName){
    
      document.getElementById("ErrA").innerHTML=" "
    
      const body =
      {
        
        UserName:EditName, 
        Id:Id,
        Active:Action,
        NormalizedUserName:EditName
       
      }
      console.log('body',body);
    
    
      axios({
             method:"POST",
             //url :`${BASE_URL}/tc/UpdateAspNetUser`,
             url: `${BASE_URL}/Foundation/FoundationUpdateUser`,
             data:body, 
             headers: {
                  "Content-type": "multipart/form-data",
                  "Authorization": "Bearer " + `${token}`,
              }     
          }) 
    
         .then((response) =>{
         console.log(response.data);
    
    
         if(response.data.status === "Success"){
         
                 alert("Updated")
              // toast.success("Updated")
            
              //localStorage.setItem("EditData",JSON.stringify(response.data))
           
          
              //localStorage.setItem('username',EditName);
    
              //  setActive(false)
    
              // setInActive(false)
    
              if(checkname===UserName){
    
                localStorage.setItem('username',EditName);
            }
    
              setTimeout(() => {
            
                window.location.href="/?#/FoundAdduser"
             
              }, 2000);
            }
    
    
            
    
      })
      .catch(error => {
        console.log(error);
        alert("Failed to Update !")
      // toast.warning("failed to Update")   
      })
        
    
    }
    
    
    }

  return (
<div className='foundation-addmain'>
<ToastContainer
position="top-center"
autoClose={1000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>

<div className="foundation-addgrid-layout">
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundAdduser'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Edit User</span>
    </div>
    </div>


   {/* EditPopup */}

   <div className="modal-dialog" role="document">
      <div className="modal-content">
      
   <form  id="edittcform" onSubmit={()=>updateFound()}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
          <input type="text" id="EditName" defaultValue={userName}/>
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">

          <input type="text" defaultValue={email} readOnly/>

          </div>
        <div className="md-form mb-5">
        {/* <input  value={passwordHash} id="Gpassword"/> */}
       {/* <input type="checkbox"   id="Generatcheck" onClick={ChangePassword}/>&nbsp; */}
          <span className='col-sm-6'  id="Generatefoundbox" ><span id="Gpass">Password</span></span> 
         <button id="Generatefoundbtn" className='col-sm-3' type='button'  onClick={GeneratePassword} >Generate</button>
    
         </div>
        
<div className="md-form mb-3">

{ActiveState===0 ? 
    <center>
 <input type="checkbox" id="foundactiveswitch"
              className="Activecheckbox" onChange={()=> setActive(1)}/>
  <label for="foundactiveswitch" className="foundtoggleactive">
       

<p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


  </label>

  </center>
:

<center>
<input type="checkbox" id="foundinactiveswitch"
         class="InActivecheckbox"  onChange={()=> setActive(0)}/>
<label for="foundinactiveswitch" className="foundtoggleinactive">
  

<p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


</label>

</center>

 }
 
{/* <button id ='oatInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button> */}


</div>


       
      </div>
      <div className="modal-footer d-flex justify-content-center" >
        <button type="submit" id='foundation-section-buttonA'>Save Changes</button>
      </div>
      </form>
    </div>
  </div>




</div>
  )
}
export default FoundEditPopMain
